/**
 * Extracts the path from the menu url. Guarantees there is *not* a trailing slash.
 * A trailing slash throws off route matching when applied as React Router's base.
 * @returns {string} a path without a trailing slash.
 */
export const deriveBasename = (menuUrl: string): string => {
  return new URL(menuUrl).pathname.replace(/\/?$/, '');
};

/**
 * Strips a partner's basename prefix from a request path, yielding the
 * root-relative path React Router actually matches against. `basename` is
 * expected in `deriveBasename`'s no-trailing-slash form (e.g. `/shop`, or `''`
 * for a root-mounted menu). Only strips on a path-segment boundary, so
 * `/shopping` is never mistaken for the `/shop` basename.
 * @returns {string} the path relative to the basename, always leading-slashed.
 */
export const stripBasename = (
  path: string = '/',
  basename: string = '/'
): string => {
  if (!basename) return path;
  if (path === basename) return '/';
  if (path.startsWith(`${basename}/`)) return path.slice(basename.length);
  return path;
};
